module.exports = __webpack_public_path__ + "static/img/313_TO8_2308.58983b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/313_TO8_2308.jpg
// module id = yD0N
// module chunks = 0